<template>
    <div>
        <div class="flex justify-between bg-primary-navy rounded-xl px-1 flex-wrap">
            <div class="shipping_container">
                <p><img src="./icons/locationIcon.svg" />Origin: {{ getNewSender.address && getNewSender.address.name ?
                    getNewSender.address.name : '' }} ({{ getNewSender.mobile || '' }})</p>
                <p><img src="./icons/tip_icon.svg" />Total Item Count: {{ getReceieverWithPackages.length || '0' }}</p>
            </div>

            <div class="shipping_container">
                <p><img src="./icons/tax_icon.svg" />Batch ID: </p>
                <p><img src="./icons/tax_icon.svg" />Total Weight: {{ getTotalWeight }}Kg</p>
            </div>

            <div class="shipping_container">
                <p><img src="./icons/tax_icon.svg" />Delivery Type: Door-to-Door</p>
                <p><img src="./icons/tip_icon.svg" /> Total Shipping Cost: N {{ shipping && shipping.transaction &&
                    shipping.transaction.breakDown ?
                    amountFomatter(shipping.transaction && shipping.transaction.breakDown &&
                        shipping.transaction.breakDown.totalCost) : 'N/A' }}</p>
            </div>
        </div>

        <div>
            <PackagesList :shipping="shipping" />
        </div>

        <div class="mt-4">
            <h2>PAYMENT summary</h2>
            <div class="pay_summary_wrapper">
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/service_icon.svg" /></div>
                    <div class="img_property">
                        <span>Service</span>
                        <b>On Demand</b>
                    </div>
                </div>
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/ship_cost.svg" /></div>
                    <div class="img_property">
                        <span>Net Shipping Cost (₦)</span>
                        <b>{{ newCostEngine && newCostEngine.netPrice ?
                            amountFomatter(newCostEngine.netPrice) : '0' }}</b>
                    </div>
                </div>
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/special_handle.svg" /></div>
                    <div class="img_property">
                        <span>Handling Charges (₦)</span>
                        <b>{{ newCostEngine && newCostEngine.handlingCharges ?
                            amountFomatter(newCostEngine.handlingCharges) : '0' }}</b>
                    </div>
                </div>
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/discount_icon.svg" /></div>
                    <div class="img_property">
                        <span>Discount Total (₦)</span>
                        <b>{{ shippingDetail && shippingDetail.discountedPrice ? shippingDetail.discountedPrice : 0
                            }}</b>
                    </div>
                </div>
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/tax_icon.svg" /></div>
                    <div class="img_property">
                        <span>Tax/VAT (₦)</span>
                        <b>{{ newCostEngine && newCostEngine.vat ?
                            amountFomatter(newCostEngine.vat) : '0' }}</b>
                    </div>
                </div>
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/total_payment.svg" /></div>
                    <div class="img_property">
                        <span>Total Payment (₦)</span>
                        <b>{{ newCostEngine && newCostEngine.cost ?
                            amountFomatter(newCostEngine.cost) : '0' }}</b>
                    </div>
                </div>
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/tip_icon.svg" /></div>
                    <div class="img_property">
                        <span>Tip (₦)</span>
                        <b>{{ shipping && shipping.transaction && shipping.transaction.breakDown ?
                            shipping.transaction.tipAmount : '0' }}</b>
                    </div>
                </div>
                <div class="package_props">
                    <div class="img_icon"><img src="./icons/payment_due.svg" /></div>
                    <div class="img_property">
                        <span>Payment Due (₦)</span>
                        <b>{{ shippingDetail && shippingDetail.paymentDue ?
                            amountFomatter(shippingDetail.paymentDue) : '0' }}</b>
                    </div>
                </div>
            </div>
        </div>


        <div>
            <div class="slice-option">
                <div class="flex justify-between items-center">
                    <label class="label whitespace-no-wrap">Tips</label>
                    <div class="w-full flex mt-1 gap-4 justify-end">
                        <label for="firtsTip" class="radio-label">
                            <input class=" bg-primary-yellow text-secondary-yellow" name="tip" type="radio"
                                id="firtsTip" value="fixed" v-model="tipType" />
                            Amount
                            <span></span>
                        </label>

                        <label for="lastAddress" class="radio-label">
                            <input type="radio" v-model="tipType" value="percentage" id="lastAddress" name="tip" />
                            Percentage
                            <span></span>
                        </label>
                    </div>
                </div>
                <input v-if="tipType === 'fixed'" type="number" class="input-mini" placeholder="--Enter--"
                    v-model="tipAmount" />
                <div v-if="tipType !== 'fixed'" class="flex items-center gap-2">
                    <button v-for="tip in tipsOpt" :key="tip.value" class="but_tip" @click="tipPercent = tip.value"
                        :class="{ active: tipPercent == tip.value }">{{ tip.name || '' }}</button>
                </div>
                <p class="text-sm mt-3 text-primary-green">Tips are a nice way to show your appreciation, but they are
                    optional. They can be applied to both "Pay Now" and "Self-Booking Pay on Delivery" options.</p>
            </div>
        </div>

        <div class="flex flex-wrap  px-3 pl-0 py-4">
            <div class="flex items-center flex-wrap">
                <p class="font-bold w-auto pb-1 mr-4">Select Payment Method</p>
                <div class="w-auto flex mt-1 gap-4 justify-start whitespace-nowrap">
                    <label for="dropAtTerminal" class="radio-label">
                        <input class=" bg-primary-yellow text-secondary-yellow" name="senderShippingMethod" type="radio"
                            id="dropAtTerminal" value="onDelivery" v-model="paymentMethod" />
                        Pay on Delivery
                        <span></span>
                    </label>

                    <label for="PickAtAddress" class="radio-label">
                        <input type="radio" v-model="paymentMethod" value="PayNow" id="PickAtAddress"
                            name="senderShippingMethod" />
                        Pay Now
                        <span></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="flex w-full items-center justify-between py-4 px-4">
            <button @click="goBack" class="underline">
                Back
            </button>
            <button class="py-1 px-2 rounded bg-primary-yellow">
                <el-dropdown class="text-black" trigger="click">
                    <button class=" font-semibold  flex items-center ">
                        <span class="mr-3 pr-2">Select</span>
                        <el-icon class="el-icon--right"> <arrow-down-filled /></el-icon>
                    </button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="paymentMethod === 'PayNow'">
                            <button @click="showPaymentModalFunc" class="text-base whitespace-nowrap">Charge
                                Card</button>
                        </el-dropdown-item>

                        <el-dropdown-item v-if="paymentMethod === 'PayNow' && $_isDevelopment">
                            <button>Charge Wallet</button>
                        </el-dropdown-item>

                        <el-dropdown-item v-if="paymentMethod !== 'PayNow'">
                            <button @click="showCashPaymentModalFunc">Cash</button>
                        </el-dropdown-item>

                        <el-dropdown-item v-if="paymentMethod !== 'PayNow' && $_isDevelopment">
                            <button>POS</button>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </button>
        </div>

        <PaymentModal :transactionId="transactionId" :costEngine="newCostEngine" @close-modal="showPaymentModal = false"
            :show-modal="showPaymentModal" :tipInfo="tipInfo" />

        <!-- <CancleBooking @close-modal="closeCancleBooking = false" :showModal="closeCancleBooking" /> -->

        <CashPaymentModal :costEngine="newCostEngine" :transactionId="transactionId"
            @close-modal="closeCashModal = false" :showModal="closeCashModal" :tipInfo="tipInfo" />
    </div>
</template>

<script>
import PaymentModal from "./modals/PaymentModal.vue";
// import CancleBooking from "./modals/CancleBooking.vue";
import CashPaymentModal from "./modals/CashPaymentModal.vue";
import PackagesList from "./module/PackagesList.vue"

export default {
    name: 'newbookingpayment',
    components: {
        PaymentModal,
        // CancleBooking,
        CashPaymentModal,
        PackagesList
    },
    data() {
        return {
            tipType: "fixed",
            tipAmount: undefined,
            tipPercent: undefined,
            paymentMethod: 'onDelivery',
            showPaymentModal: false,
            shipping: {},
            closeCashModal: false,
            shippingDetail: {},
            addressDebounce: null,
            tipsOpt: [
                { name: '1%', value: 1 },
                { name: '2%', value: 2 },
                { name: '5%', value: 5 },
                { name: '10%', value: 10 }
            ]
        }
    },
    computed: {
        tipInfo() {
            return {
                tip: this.tipAmount,
                tipPercent: this.tipPercent,
                tipType: this.tipType
            }
        },
        transactionId() {
            return this.shipping?.transactionId
        },
        costEngine() {
            return this.shipping.transaction?.breakDown
        },
        newCostEngine() {
            return this.shippingDetail?.totalCost
        },
        getCreatedShipment() {
            return this.$store.getters.getCreatedBooking;
        },
        getReceieverWithPackages() {
            return this.$store.getters.getSavedNewRecieverPackage;
        },
        getNewSender() {
            return this.$store.getters.getSavedNewSender;
        },
        getTotalWeight() {
            return this.getReceieverWithPackages.map((item) => Number(item.package.estimatedWeight)).reduce(((prev, sum) => prev + sum), 0)
        },
        isPayNow() {
            return this.paymentMethod === 'PayNow'
        },
    },
    watch: {
        tipType(val) {
            val == 'amount' ? (this.tipPercent = undefined) : (this.tipAmount = undefined)
        },
        async tipInfo() {
            const payload = {
                ...this.$store.getters?.getCreatedBookingPayload,
                tipAmount: this.tipType === 'fixed' ? Number(this.tipAmount) : `${this.tipPercent}`,
                tip: this.tipType
            }
            if ((Number(this.tipAmount) >= 0 && this.tipType === 'fixed') || (this.tipType === 'percentage' && this.tipPercent)) {
                clearTimeout(this.addressDebounce); // 🧹 Clear previous timer
                this.addressDebounce = setTimeout(async () => {
                    await this.$_createNewBooking(payload);
                    await this.getShipping()
                }, 500);
            }

        }
    },
    activated() {
        this.getShipping()
    },
    methods: {
        showCashPaymentModalFunc() {
            this.closeCashModal = true;
            this.$store.dispatch("setNewBookingpaymenttype", 'cash');
        },
        showPaymentModalFunc() {
            this.$store.dispatch("setNewBookingpaymenttype", 'card');
            this.showPaymentModal = true;
        },
        goBack() {
            this.$store.dispatch('setSavedActiveTab', 2)
        },
        async getShipping() {
            const response = await this.$_getCreatedNewBooking(this.getCreatedShipment?.id);
            this.shippingDetail = response.data.data;
            this.shipping = response.data.data.shipping;
        }
    },
}
</script>

<style lang="scss" scoped>
.package_props {
    @apply flex justify-center items-start;

    div {
        img {
            @apply mt-1 w-5;
        }
    }
}

.shipping_container {
    @apply w-full sm:w-[48%] sm:mr-[2%] lg:w-[31.33333%] text-white text-sm py-2 px-1;

    p {
        @apply py-1 flex items-center;

        img {
            @apply mr-2;
        }
    }
}

.img_icon {
    @apply mr-1 !w-[30px] flex justify-center
}

.img_property {
    @apply flex-1 flex-wrap flex text-sm;

    span {
        @apply block w-full pb-1 opacity-50
    }

    b {
        @apply font-[500]
    }
}

.pay_summary_wrapper {
    @apply mt-3 w-full flex flex-wrap;

    div {
        @apply w-full sm:w-[48%] sm:mr-[2%] md:w-[31.333333%] lg:w-[23%] text-sm py-2 px-1;
    }
}

.slice-option {
    @apply mt-4 sm:mt-7 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.label {
    @apply w-full block whitespace-nowrap;
}

.input-mini {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* For Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.but_tip {
    @apply py-2 px-5 rounded mr-2 border-[1px] border-primary-palegrey/50;

    &.active {
        @apply bg-primary-navy text-white;
        box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    }
}
</style>